// extracted by mini-css-extract-plugin
export default {"addButton":"PlusIcon_addButton__F8Twk","container":"PlusIcon_container__Qt+UQ","active":"PlusIcon_active__usgkC","label":"PlusIcon_label__1YNsp"};